const actions = {
    OPEN_AGGREGATOR_MODAL: "OPEN_AGGREGATOR_MODAL",
    ADD_AGGREGATOR: "ADD_AGGREGATOR",
    ADD_AGGREGATOR_SUCCESS: "ADD_AGGREGATOR_SUCCESS",
    ADD_AGGREGATOR_FAILED: "ADD_AGGREGATOR_FAILED",
    GET_AGGREGATOR: "GET_AGGREGATOR",
    GET_AGGREGATOR_SUCCESS: "GET_AGGREGATOR_SUCCESS",
    GET_AGGREGATOR_FAILED: "GET_AGGREGATOR_FAILED",
    RESET_AGGREGATOR:"RESET_AGGREGATOR",
    PREVIEW_AGGREGATOR_MODAL: "PREVIEW_AGGREGATOR_MODAL",
    SET_PREVIEW_DATA: "SET_PREVIEW_DATA",
    UPDATE_AGGREGATOR: "UPDATE_AGGREGATOR",
    UPDATE_AGGREGATOR_SUCCESS: "UPDATE_AGGREGATOR_SUCCESS",
    UPDATE_AGGREGATOR_FAILED: "UPDATE_AGGREGATOR_FAILED:",

    getAggregator: () => ({
        type: actions.GET_AGGREGATOR,
    }),
    getAggregatorSuccess: (data) => ({
        type: actions.GET_AGGREGATOR_SUCCESS,
        data
    }),
    getAggregatorFailed: (error) => ({
        type: actions.GET_AGGREGATOR_FAILED,
        error
    }),
    openAddAggregatorModal: () => ({
        type: actions.OPEN_AGGREGATOR_MODAL,
    }),
    addAggregator: (data) => ({
        type: actions.ADD_AGGREGATOR,
        payload: { data }
    }),
    addAggregatorSuccess: (message, regionResult) => ({
        type: actions.ADD_AGGREGATOR_SUCCESS,
        message, regionResult
    }),
    addAggregatorFailed: (error) => ({
        type: actions.ADD_AGGREGATOR_FAILED,
        error
    }),
    resetAggregator: () => ({
        type: actions.RESET_AGGREGATOR,
    }),
    previewAggregatorModal: () => ({
        type: actions. PREVIEW_AGGREGATOR_MODAL,
    }),
    setPreviewData: (data) => ({
        type: actions.SET_PREVIEW_DATA,
         data 
    }),
    updateAggregator: ( id,data) => ({
        type: actions.UPDATE_AGGREGATOR,
        payload: { id,data }
    }),
    updateAggregatorSuccess: (message) => ({
        type: actions.UPDATE_AGGREGATOR_SUCCESS,
        message
    }),
    updateAggregatorFailed: (error) => ({
        type: actions.UPDATE_AGGREGATOR_FAILED,
        error
    }),

}
export default actions;